import React from "react";
import { getInitials } from "../lib/userUtils";
import type { Profile } from "../types/profile";

interface UserInfoProps {
  profile: Profile | null | undefined;
  showAvatar?: boolean;
  avatarSize?: number;
  className?: string;
}

export const UserInfo: React.FC<UserInfoProps> = ({
  profile,
  showAvatar = true,
  avatarSize = 24,
  className = "",
}) => {
  if (!profile) return null;

  const displayName = profile.full_name || profile.email;
  const initials = profile.full_name
    ? profile.full_name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : getInitials(profile.email);

  return (
    <div className={`ob-user-info ${className}`}>
      {showAvatar && (
        <div className="ob-user-info-avatar" style={{ width: avatarSize, height: avatarSize }}>
          {profile.avatar_url ? (
            <img src={profile.avatar_url} alt={displayName} />
          ) : (
            <div className="ob-user-info-avatar-placeholder">
              {initials}
            </div>
          )}
        </div>
      )}
      <span className="ob-user-info-name">{displayName}</span>
    </div>
  );
};
